import React, { useState } from "react";
import {
  Container,
  Icon,
  TitleContainer,
  Title,
  BottomContainer,
  HorizontalLine,
} from "./styled.components";
import OnGoingPNG from "../../../assets/images/onGoing.png";
import CompletedPNG from "../../../assets/images/completed.png";
import OnGoingProject from "./onGoingprojects";
import CompletedProject from "./completedProjects";
const heading = [
  {
    id: "1",
    title: "On-Going",
    icon: OnGoingPNG,
  },
  {
    id: "2",
    title: "Completed",
    icon: CompletedPNG,
  },
];
const Tab = ({ projects }) => {
  const [active, setActive] = useState(heading[0].id);
  let completedProjects = [];
  let onGoingProjects = [];

  const getcompletedProjects = projects.map((proj_) => {
    if (proj_.status === "completed") {
      completedProjects.push(proj_);
    }
  });
  const getonGoingProjects = projects.map((proj_) => {
    if (proj_.status === "on-going") {
      onGoingProjects.push(proj_);
    }
  });

  const handleClick = () => {
    setActive((e) => !e);
  };

  return (
    <>
      <Container>
        <TitleContainer>
          <Icon src={heading[0].icon} />
          <Title active={active} onClick={handleClick} key={heading[0].id}>
            {heading[0].title}
          </Title>
        </TitleContainer>
        <TitleContainer>
          <Icon src={heading[1].icon} />
          <Title active={!active} onClick={handleClick} key={heading[1].id}>
            {heading[1].title}
          </Title>
        </TitleContainer>
        <BottomContainer></BottomContainer>
      </Container>
      <HorizontalLine />
      {active && projects.length > 0 ? (
        <OnGoingProject onGoingProjects={onGoingProjects} />
      ) : (
        <CompletedProject CompletedProjects={completedProjects} />
      )}
    </>
  );
};

export default Tab;
